<template>
  <svg
    class="xpz-svg-icon"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
    <line x1="9" y1="9.5" x2="9.01" y2="9.5" />
    <line x1="15" y1="9.5" x2="15.01" y2="9.5" />
  </svg>
</template>

<script>
export default {
  name: "IconEmoji",
};
</script>

<style scoped>
.xpz-svg-icon {
  display: block;
  width: 1em;
  height: 1em;
}
</style>
